<template>
  <div id="pageProfile" class="contact-page">
    <!-- Header -->
    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <!-- Info -->
    <section class="profile-hello text center">
      <b class="bold">רופא/ה יקר/ה,</b>
      <br />
      פרופיל הרופא מוצג באתר האינטרנט של ביה"ח ומשמש את הגולשים לקבלת מידע
      אודותיך. ניתן לעדכן מידע חדש או לערוך מידע קיים ככל הנדרש.
    </section>

    <!-- Hero -->
    <section class="profile-hero bg--blue center tx--white">
      <div class="profile-image relative">
        <img :src="currentUser.image" />
      </div>
      <h1 class="title bold tx--white no-marge">
        {{ currentUser.title }} {{ currentUser.first_name }}
        {{ currentUser.last_name }}
      </h1>
      <div class="text tx--white">{{ currentUser.job }}</div>
      <router-link
        to="profile-edit"
        class="profile-edit-bt flex flex--content--center tx--under tx--white"
      >
        <img src="assets/img/svg/ic-pen-white.svg" />
        עריכת פרופיל
      </router-link>

      <!-- Page -->
    </section>
    <div class="inner_group bg--white no-marge profile-inner">
      <h2 class="title">קצת עלי</h2>
      <div class="text">
        {{ currentUser.about }}
      </div>
    </div>

    <!-- Roles -->
    <div class="book_surgery desk_inner_width active no-marge">
      <div class="book_surgery_top flex">
        <span class="title">תפקידים</span>
      </div>
      <div class="book_surgery_open toggleInner" style="display:block">
        <div class="inner_group bg--white no-marge">
          <div
            class="add_new_row"
            v-for="(role, i) in currentUser.roles"
            :key="i"
          >
            <div class="text">{{ role }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Clinical experience -->
    <div class="book_surgery desk_inner_width active no-marge">
      <div class="book_surgery_top flex">
        <span class="title">ניסיון קליני</span>
      </div>
      <div class="book_surgery_open toggleInner" style="display:block">
        <div class="inner_group bg--white no-marge">
          <div
            class="add_new_row"
            v-for="(exp, i) in currentUser.clinical_exp"
            :key="i"
          >
            <div class="text">
              {{ exp }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Education -->
    <div class="book_surgery desk_inner_width active no-marge">
      <div class="book_surgery_top flex">
        <span class="title">השכלה</span>
      </div>
      <div class="book_surgery_open toggleInner" style="display:block">
        <div class="inner_group bg--white no-marge">
          <div
            class="add_new_row"
            v-for="(edu, i) in currentUser.education"
            :key="i"
          >
            <div class="text">
              {{ edu }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Courses -->
    <div class="book_surgery desk_inner_width active no-marge">
      <div class="book_surgery_top flex">
        <span class="title">השתלמויות</span>
      </div>
      <div class="book_surgery_open toggleInner" style="display:block">
        <div class="inner_group bg--white no-marge">
          <div
            class="add_new_row"
            v-for="(course, i) in currentUser.courses"
            :key="i"
          >
            <div class="text">
              {{ course }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Memberships -->
    <div class="book_surgery desk_inner_width active no-marge">
      <div class="book_surgery_top flex">
        <span class="title">חברות באיגודים מקצועיים</span>
      </div>
      <div class="book_surgery_open toggleInner" style="display:block">
        <div class="inner_group bg--white no-marge">
          <div
            class="add_new_row"
            v-for="(ms, i) in currentUser.memberships"
            :key="i"
          >
            <div class="text">
              {{ ms }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Profile",
  components: { DashboardHeader, Menu },
  data() {
    return {
      license: "",
      currentUser: {
        title: "",
        first_name: "",
        last_name: "",
        image: "",
        about: "",
        job: "",
        roles: [],
        clinical_exp: [],
        education: [],
        courses: [],
        memberships: []
      }
    };
  },
  computed: {
    ...mapGetters(["MENU_ACTIVE"])
  },
  methods: {
    ...mapActions(["GET_USER_PROFILE"])
  },
  async created() {
    window.scrollTo(0, 0);
    this.currentUser = await this.GET_USER_PROFILE();
  }
};
</script>
